export const text = {
  header: "LED PRODUCTS WITH THE LATEST TECHNOLOGY",
  copy: "Since our founding in 2001, TraStar's goal has been to provide our customers with the best quality LED products and services. With over 25 years of experience, TraStar is an industry leader specializing in LED products including High Mast and Cobra Head fixtures.",
  button: "Read More About Us",
};
